<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTenant } from "../getTenant.js";
	import translations from "./Products.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import Link from "../components/Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import {
		ProductType,
		productTypeNameMap,
		productTypeShortDescMap,
		productTypeSlugMap,
	} from "../../../core/schema/ProductType.js";
	import { getProductsByTypePath } from "../../../core/schema/paths/getProductsByTypePath.js";
	import racksImage from "../assets/images/racks/racks-hero.jpg";
	import robotsImage from "../assets/images/robots/PowerStore3.jpg";
	import cranesImage from "../assets/images/cranes/Tornado2.jpg";
	import conveyorsImage from "../assets/images/integration/integration-hero.png";
	import softwareImage from "../assets/images/solutions/vertinode.jpg";

	const productTypeImageMap: Record<ProductType, string> = {
		[ProductType.VerticalTowerSystems]: racksImage,
		[ProductType.AutonomousRobots]: robotsImage,
		[ProductType.StackerCranes]: cranesImage,
		[ProductType.ConveyorSystems]: conveyorsImage,
		[ProductType.ControlSoftware]: softwareImage,
	};

	const translate = getTranslate(translations);
	const tenant = getTenant();

	const productTypes: ProductType[] = Object.values(ProductType);
	const [firstProductType = ProductType.VerticalTowerSystems] = productTypes;
	const firstProductTypeAnchor = productTypeSlugMap[firstProductType][tenant.locale];
</script>

<Layout>
	<div class="container">
		<section class="mx-4 md:mx-0">
			<div class="flex items-center gap-4 md:mx-16 xl:mx-32">
				<span class="bg-ltprimary-200 h-px w-8"></span>
				<span class="text-ltprimary-200 uppercase">{translate("tag")}</span>
			</div>
			<div
				class="mt-8 flex flex-col gap-8 md:mx-16 md:mt-16 md:gap-12 xl:mx-32 xl:h-[16.5rem] xl:flex-row xl:items-center xl:gap-32"
			>
				<div class="flex-1 xl:h-[16.5rem] xl:max-w-3xl">
					<h1 class="text-ltprimary p-0 font-light uppercase tracking-wider">
						{translate("introductoryHeadline")}
					</h1>
				</div>
				<div class="flex flex-1 flex-col gap-8 xl:h-[14.5rem] xl:max-w-3xl xl:gap-16">
					<div class="lg:text-md/normal tracking-[0.02em]">{translate("introductoryDescription")}</div>
					<div>
						<Link asButton variant="secondary" icon={arrowRight} href="#{firstProductTypeAnchor}">
							{translate("exploreCategories")}
						</Link>
					</div>
				</div>
			</div>
		</section>
	</div>

	<section class="border-lttertiary mt-16 border-t lg:mt-24">
		{#each productTypes as productType, i (productType)}
			<div
				id={productTypeSlugMap[productType][tenant.locale]}
				class="border-lttertiary scroll-mt-24 border-b px-4 md:px-8 xl:h-[32rem] xl:px-32"
			>
				<div class="border-lttertiary grid grid-cols-1 md:grid-cols-2 xl:h-full xl:border-x">
					<div
						class="border-lttertiary flex gap-2 overflow-hidden p-4 md:p-6 xl:h-full {i % 2 === 0
							? 'md:order-1 xl:border-r'
							: 'md:order-2'}"
					>
						<img
							src={productTypeImageMap[productType]}
							alt={productTypeNameMap[productType][tenant.locale]}
							class="h-56 w-full object-cover md:h-72 xl:h-full"
						/>
					</div>
					<div
						class="border-lttertiary flex flex-col justify-center gap-6 px-4 py-8 md:px-8 md:py-10 xl:h-full xl:gap-10 xl:px-16 xl:py-12 {i %
							2 ===
						0
							? 'md:order-2'
							: 'md:order-1 xl:border-r'}"
					>
						<h2 class="text-ltprimary mb-0 font-light uppercase tracking-[0.02em]">
							{productTypeNameMap[productType][tenant.locale]}
						</h2>
						<p class="!mb-0 font-normal leading-[1.6] tracking-[0.02em] text-black">
							{productTypeShortDescMap[productType][tenant.locale]}
						</p>
						<div>
							<Link
								asButton
								variant="secondary"
								icon={arrowRight}
								href="/{getProductsByTypePath(productType)[tenant.locale]}"
							>
								{translate("moreInfo")}
							</Link>
						</div>
					</div>
				</div>
			</div>
		{/each}
	</section>
	<section class="!mb-0">
		<ContactForm />
	</section>
</Layout>
